import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import type { RatingsSectionProps, RatingsData } from "./types";
import VoteBreakdownTooltip from "./tooltips/VoteBreakdownTooltip";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { WAVE_VOTE_STATS_LABELS, WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
interface ParticipationDropRatingsTotalSectionProps extends RatingsSectionProps {
  readonly ratingsData: RatingsData;
}
export default function ParticipationDropRatingsTotalSection(t0) {
  const $ = _c(25);
  const {
    drop,
    ratingsData
  } = t0;
  const {
    currentRating
  } = ratingsData;
  const votingLabel = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
  const totalValueClass = currentRating < 0 ? "tw-text-rose-400" : "tw-text-iron-50";
  const t1 = `tw-font-medium ${totalValueClass}`;
  const t2 = currentRating < 0 && "-";
  let t3;
  if ($[0] !== currentRating) {
    t3 = formatNumberWithCommas(Math.abs(currentRating));
    $[0] = currentRating;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = <span className={t1}>{t2}{t3}</span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== currentRating || $[7] !== drop.rating_prediction) {
    t5 = <DropVoteProgressing current={currentRating} projected={drop.rating_prediction} compact={true} />;
    $[6] = currentRating;
    $[7] = drop.rating_prediction;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="tw-relative tw-inline-flex tw-items-center tw-gap-x-1.5">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = `total-rating-${drop.id}`;
  let t8;
  if ($[12] !== t7 || $[13] !== votingLabel) {
    t8 = <span className="tw-cursor-help tw-whitespace-nowrap tw-font-normal tw-text-iron-400" data-tooltip-id={t7}>{votingLabel} {WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
    $[12] = t7;
    $[13] = votingLabel;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = `total-rating-${drop.id}`;
  let t10;
  if ($[15] !== drop || $[16] !== ratingsData) {
    t10 = <VoteBreakdownTooltip drop={drop} ratingsData={ratingsData} />;
    $[15] = drop;
    $[16] = ratingsData;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <Tooltip id={t9} place="top" offset={8} opacity={1} positionStrategy="fixed" style={TOOLTIP_STYLES}>{t10}</Tooltip>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t6 || $[23] !== t8) {
    t12 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-text-sm tw-leading-5">{t6}{t8}{t11}</div>;
    $[21] = t11;
    $[22] = t6;
    $[23] = t8;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}